import { render, staticRenderFns } from "./productMotor.vue?vue&type=template&id=b59e6ae2&"
import script from "./productMotor.vue?vue&type=script&lang=ts&"
export * from "./productMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports